import Utils from '../../services/utils';

export const documentTypesValueLabelList = [
  { value: '11', label: 'Registro civil', abreviation: 'RC' },
  { value: '12', label: 'Tarjeta de identidad', abreviation: 'TI' },
  { value: '13', label: 'Cédula de ciudadanía', abreviation: 'CC' },
  { value: '21', label: 'Tarjeta de extranjería', abreviation: 'TE' },
  { value: '22', label: 'Cédula de extranjería', abreviation: 'CE' },
  { value: '31', label: 'NIT', abreviation: 'NIT' },
  { value: '41', label: 'Pasaporte', abreviation: 'P' },
  { value: '42', label: 'Documento de identificación extranjero', abreviation: 'DIE' }
];

export const documentTypesLabelsObject = Utils.valueLabelListToLabelsObject(documentTypesValueLabelList);

export const documentTypesValueAbreviationList = documentTypesValueLabelList.map(({ value, abreviation, label }) => ({
  value,
  label: `${abreviation} - ${label}`,
  shortLabel: abreviation
}));

export const documentTypesAbbreviationsObject = documentTypesValueLabelList.reduce(
  (prev, { value, abreviation }) => ({ ...prev, [value]: abreviation }),
  {}
);
